import { render, staticRenderFns } from "./StockInfoHeader.vue?vue&type=template&id=6819ec99&scoped=true"
import script from "./StockInfoHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StockInfoHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StockInfoHeader.vue?vue&type=style&index=0&id=6819ec99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6819ec99",
  null
  
)

export default component.exports